import { Button, Col, Flex, Grid, Image, Row, Space, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCommunitySettings } from '@guuru/community-web';
import events from '@guuru/events-web';
import { MarkdownRender } from '@guuru/react-markdown-render';
import { Translation } from '@guuru/translation-web';
import Paragraph from '../../Paragraph';

const { useBreakpoint } = Grid;

const getInvitationLink = (partnerId: string) =>
  `https://guuru.app.link/?$deeplink_path=community/${partnerId}&~customer_campaign=${partnerId}`;

const AboutCommunity = function () {
  const {
    partnerName,
    partnerId,
    invitationHeroUrl,
    rewards: { isPoints, goodAmount },
  } = useCommunitySettings();
  const { t } = useTranslation();
  const { xs } = useBreakpoint();
  const amount = isPoints ? `${goodAmount} PTS` : goodAmount;
  return (
    <Row gutter={[64, 36]} align="middle">
      <Col xs={24} md={10} xxl={6} style={{ textAlign: 'center' }}>
        <Image
          preview={false}
          src={invitationHeroUrl || undefined}
          fallback="https://cdn.guuru.com/assets/images/pages/invitation_hero.png"
          style={{ maxWidth: '500px' }}
        />
      </Col>
      <Col xs={24} md={14} xxl={18}>
        <Flex gap={24} vertical>
          <Space orientation="vertical" size={12}>
            <Typography.Title level={3}>
              {t('pages:::descriptionTitle', { partnerName })}
            </Typography.Title>
            <Paragraph type="secondary">
              <MarkdownRender
                content={t('pages:::descriptionIntro', { partnerName, amount })}
                inline
              />
              <Translation
                translationKey="pages:::rewardsDetails"
                placeholders={{ partnerName }}
              />
            </Paragraph>
          </Space>
          <Row>
            <Button
              block={xs}
              size="large"
              type="primary"
              shape="round"
              href={getInvitationLink(partnerId)}
              onClick={() => events.openInvitationLink()}
            >
              {t('pages:::joinButton')}
            </Button>
          </Row>
        </Flex>
      </Col>
    </Row>
  );
};

export default AboutCommunity;
